const quoteTerm = (term) => `"${term}"`;

const normalizeSinglesQuery = (value) => {
  const terms = value
    .trim()
    .split(/\s+/)
    .map((term) => term.replace(/[^\p{L}\p{N}\/.'+-]/gu, ''))
    .filter((term) => term && !/^(and|or|not)$/i.test(term));

  if (!terms.length) return '';

  const exactPhrase = quoteTerm(terms.join(' '));
  if (terms.length === 1) return `product_type:Singles AND ${exactPhrase}`;

  const exactTerms = terms.map(quoteTerm).join(' AND ');
  const compactPhrase = quoteTerm(terms.join(''));

  return `product_type:Singles AND (${exactPhrase} OR (${exactTerms}) OR ${compactPhrase})`;
};

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-aniware-singles-search]')) return;

  const input = form.querySelector('[data-aniware-singles-search-input]');
  if (!(input instanceof HTMLInputElement)) return;

  const query = normalizeSinglesQuery(input.value);
  if (!query) {
    event.preventDefault();
    input.focus();
    return;
  }

  input.value = query;
});
